export default class IndexController {
  /* @ngInject */
  constructor(user, $state) {
    if (process.env.ENV !== "prod") {
      if (!user.defaultOrganization) {
        $state.go("createOrganization");
      } else {
        $state.go("app.dashboard", {
          organization: user.defaultOrganization.slug,
        });
      }
    } else {
      if (!user.defaultOrganization) {
        $state.go("not-have-organization");
      } else {
        $state.go("app.dashboard", {
          organization: user.defaultOrganization.slug,
        });
      }
    }
  }
}
